import { createSlice } from "@reduxjs/toolkit"
import {
  addZone,
  deleteZone,
  getAllZones,
  getAllZoneList,
  getZoneDetails,
  updateZone,
  updateZoneStatus,
} from "store/actions/zoneAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  currentPage: 1,
  zones: [],
  zoneList: [],
  zoneDetails: {},
}

const usersSlice = createSlice({
  name: "zone",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL ZONES
    builder
      .addCase(getAllZoneList.pending, state => {})
      .addCase(getAllZoneList.fulfilled, (state, action) => {
        const { status, data } = action.payload
        if (status) {
          state.zoneList = data
        }
      })
      .addCase(getAllZoneList.rejected, (state, action) => {})

      .addCase(getAllZones.pending, state => {
        state.loading = true
      })
      .addCase(getAllZones.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.zones = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllZones.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE ZONE STATUS
    builder
      .addCase(updateZoneStatus.pending, state => {
        state.isLoading = true
      })
      .addCase(updateZoneStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { status } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          state.zones = state.zones.map(item =>
            item._id === id ? { ...item, status: Number(status) } : item
          )
        }
      })
      .addCase(updateZoneStatus.rejected, (state, action) => {
        state.isLoading = false
      })

    // ADD ZONE
    builder
      .addCase(addZone.pending, state => {
        state.isLoading = true
      })
      .addCase(addZone.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addZone.rejected, (state, action) => {
        state.isLoading = false
      })

    // GET ZONE DETAILS
    builder
      .addCase(getZoneDetails.pending, state => {
        state.loading = true
        state.zoneDetails = {}
      })
      .addCase(getZoneDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.zoneDetails = data
        }
      })
      .addCase(getZoneDetails.rejected, (state, action) => {
        state.loading = false
      })

    //  UPDATE ZONE
    builder
      .addCase(updateZone.pending, state => {
        state.isLoading = true
      })
      .addCase(updateZone.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateZone.rejected, (state, action) => {
        state.isLoading = false
      })

    // DELETE ZONE
    builder
      .addCase(deleteZone.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteZone.fulfilled, (state, action) => {
        const { status } = action.payload
        const { id } = action.meta.arg
        state.isLoading = false
        if (status) {
          state.zones = state.zones.filter(item => item._id !== id)
          // Decrement the totalCount if it exists
          if (state.totalCount !== null) {
            state.totalCount -= 1
          }
        }
      })
      .addCase(deleteZone.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
